module.exports = __webpack_public_path__ + "img/duidaokuaixiaoding.prt.7f438f73.jpg";